/* eslint-disable import/prefer-default-export */

import { ExampleGalleryActions } from '../../constants';

export const setIsOpen = (isOpen) => ({
  type: ExampleGalleryActions.SET_IS_OPEN,
  isOpen,
});

export const setExample = (example) => ({
  type: ExampleGalleryActions.SET_EXAMPLE,
  dossierUrl: example.dossierUrl,
  exampleGroupName: example.exampleGroupName,
  exampleName: example.exampleName,
  exampleId: example.exampleId,
  exampleDesc: example.exampleDesc,
  image: example.image,
});

export const setLinkedExample = (exampleId) => ({
  type: ExampleGalleryActions.SET_LINKED_EXAMPLE,
  exampleId,
});
